import { MessageCircle } from "lucide-react";
import { CONTACT } from "../../data/site";

const waLink = `https://wa.me/${CONTACT.phoneRaw}?text=${encodeURIComponent(
  "Hi Mamta! I'd like to order some pickles from Mamta's Kitchen."
)}`;

export const WhatsAppButton = () => (
  <a
    href={waLink}
    target="_blank"
    rel="noopener noreferrer"
    data-testid="whatsapp-float"
    aria-label="Chat on WhatsApp"
    className="fixed bottom-6 right-6 z-50 h-14 w-14 rounded-full bg-[#25D366] shadow-lg flex items-center justify-center hover:scale-105 active:scale-95 transition-transform"
  >
    <MessageCircle className="h-7 w-7 text-white" />
  </a>
);
